import * as React from "react";
import {
  WheelPicker,
  WheelPickerOption,
  WheelPickerWrapper,
} from "@ncdai/react-wheel-picker";

const peopleOptions: WheelPickerOption<number>[] = Array.from(
  { length: 10 },
  (_, i) => {
    const value = i + 1;
    return {
      label: value.toString(),
      value: value,
    };
  }
);

interface PeopleSelectWheelProps {
  onChange?: (people: number) => void;
}

export function PeopleSelectWheel({ onChange }: PeopleSelectWheelProps) {
  const [people, setPeople] = React.useState(1);

  React.useEffect(() => {
    if (onChange) {
      onChange(people);
    }
  }, [people, onChange]);

  return (
    <div className="w-full">
      <WheelPickerWrapper className="bg-transparent border-none">
        <WheelPicker
          options={peopleOptions}
          defaultValue={people}
          onValueChange={(value: number) => setPeople(value)}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
          infinite
        />
      </WheelPickerWrapper>
    </div>
  );
}
